export const CLASSES = {
    true: 'success',
    false: 'danger',

    0: 'danger',
    1: 'warning',
    2: 'info',
    3: 'primary',
    4: 'success',

    r: 'danger',
    y: 'warning',
    g: 'success',

    delete: 'danger',
    put: 'warning',
    options: 'warning',
    head: 'warning',
    post: 'primary',
    patch: 'info',
    get: 'success',

    drop: 'light-danger',
    bre_failed: 'danger',
    rejected: 'danger',
    application_rejected: 'danger',
    inactive: 'danger',
    failed: 'danger',
    error: 'danger',
    writeoff: 'danger',
    dropped: 'danger',
    closed: 'danger',
    tds: 'danger',
    adjustment: 'danger',
    rented: 'danger',
    unsigned: 'danger',
    deleted: 'danger',
    grocery: 'danger',
    medical: 'danger',
    testing: 'danger',
    dedupe: 'danger',
    pending_for_approval: 'danger',
    debit: 'danger',
    nach_bounced: 'danger',
    nap: 'danger',
    cancelled: 'danger',
    unpaid: 'danger',
    npa: 'danger',
    liability: 'danger',
    disbursement: 'danger',
    kyc_pending: 'warning',
    submit_cam: 'warning',
    kyc_approval: 'warning',
    pending_approval: 'warning',
    bre_pending: 'warning',
    pending_disbursement: 'warning',
    pending: 'warning',
    hold: 'warning',
    margin: 'warning',
    reopen: 'warning',
    automobiles: 'warning',
    hardwareservices: 'warning',
    manufacturer: 'warning',
    back_date_invoice: 'warning',
    is_suspense_balance: 'warning',

    pending_underwriting: 'info',
    activation: 'info',
    approve_cam: 'info',
    processed: 'info',
    pending_disbursal: 'info',
    scheduled: 'info',
    partially_paid: 'info',
    credit_note: 'info',
    sanction: 'info',
    submitted: 'info',
    sanctioned: 'info',
    logistics: 'info',
    apparels: 'info',
    api: 'info',
    anchor: 'info',
    upcoming: 'info',
    invoice: 'info',
    is_manually_matched: 'info',
    mandate: 'info',

    due: 'primary',
    kyc_verification: 'primary',
    credit_approval: 'primary',
    bre_approval: 'primary',
    current: 'primary',
    completed: 'primary',
    kyc_completed: 'primary',
    initiate: 'primary',
    initiated: 'primary',
    electronics: 'primary',
    system: 'primary',
    updated: 'primary',
    unassigned: 'primary',
    nach_presented: 'primary',
    bank: 'primary',

    accept_offer: 'success',
    paid: 'success',
    running: 'success',
    repayment: 'success',
    approved: 'success',
    active: 'success',
    verified: 'success',
    kyc_verified: 'success',
    stamped: 'success',
    signed: 'success',
    disbursed: 'success',
    owned: 'success',
    success: 'success',
    los: 'success',
    activated: 'success',
    activate: 'success',
    agriculture: 'success',
    primary: 'success',
    lender: 'success',
    created: 'success',
    credit: 'success',
    cashback: 'success',
    vehicle: 'success',
    assets: 'success',
    interest_accrual: 'success',
    banking_analysis: 'success',
    excess_money: 'success',
};
